/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {User, UserFromJSON, UserToJSON,} from './User';

/**
 *
 * @export
 * @interface UserListApiResult
 */
export interface UserListApiResult {
    /**
     *
     * @type {boolean}
     * @memberof UserListApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Array<User>}
     * @memberof UserListApiResult
     */
    content?: Array<User> | null;
    /**
     *
     * @type {string}
     * @memberof UserListApiResult
     */
    message?: string | null;
}

export function UserListApiResultFromJSON(json: any): UserListApiResult {
    return UserListApiResultFromJSONTyped(json, false);
}

export function UserListApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : (json['content'] as Array<any>).map(UserFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UserListApiResultToJSON(value?: UserListApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content === undefined ? undefined : (value.content === null ? null : (value.content as Array<any>).map(UserToJSON)),
        'message': value.message,
    };
}

